import { gsap } from 'gsap'
import { DrawSVGPlugin } from 'gsap/dist/DrawSVGPlugin.js'
gsap.registerPlugin(DrawSVGPlugin)

/**
 * CTA Banner component.
 * @author Dayne Coulson-Hoffacker
 */
export default class RolodexMenu {
  /**
   * Constructs a new RolodexMenu component.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element

    this.menuItems = this.element.querySelectorAll('h3')
    this.submenuItems = this.element.querySelectorAll('.category-menu-items')
    this.menuItemLinks = this.element.querySelectorAll('.menu-item-link')
    this.menuItemsWrapper = this.element.querySelector('.menu-items-wrapper')
    this.menuItemsWrapperInner = this.element.querySelector('.menu-items-wrapper-inner')
    this.topMenuItems = this.element.querySelector('.top-menu-items')
    this.topMenuItemsWrapper = this.element.querySelector('.top-menu-items-wrapper')
    this.img = this.element.querySelector('picture img')

    this.topMenuItems.addEventListener('scroll', () => {
      if (this.topMenuItems.scrollLeft + this.topMenuItems.clientWidth >= this.topMenuItems.scrollWidth) {
        this.topMenuItemsWrapper.classList.add('top-menu-items-scrolled')
      } else {
        this.topMenuItemsWrapper.classList.remove('top-menu-items-scrolled')
      }
    })

    this.menuItemsWrapperInner.addEventListener('scroll', () => {
      if (this.menuItemsWrapperInner.scrollTop > 0) {
        this.menuItemsWrapper.classList.add('menu-items-wrapper-scrolled')
      } else {
        this.menuItemsWrapper.classList.remove('menu-items-wrapper-scrolled')
      }
    })

    this.menuItems.forEach(menuItem => {
      menuItem.addEventListener('click', () => {
        this.menuItems.forEach(menuItem => {
          menuItem.classList.remove('menu-item-active')
        })
        menuItem.classList.add('menu-item-active')

        if (menuItem.dataset.categoryImage) {
          this.fadeImageToSrc(menuItem.dataset.categoryImage)
        } else {
          this.fadeImageToSrc(this.img.dataset.image)
        }

        if (menuItem.dataset.categoryTitle === 'all') {
          this.submenuItems.forEach(submenuItem => {
            submenuItem.style.display = 'block'
          })
          const submenuItemLinks = this.element.querySelectorAll('.category-menu-item a')
          submenuItemLinks.forEach(h4 => {
            h4.classList.remove('active')
          })
          submenuItemLinks[0].classList.add('active')
        } else {
          this.submenuItems.forEach(submenuItem => {
            if (submenuItem.dataset.categoryTitle === menuItem.dataset.categoryTitle) {
              submenuItem.style.display = 'block'
              const submenuItemLinks = submenuItem.querySelectorAll('.category-menu-item a')

              submenuItemLinks.forEach(h4 => {
                h4.classList.remove('active')
              })
              submenuItemLinks[0].classList.add('active')

            } else {
              submenuItem.style.display = 'none'
            }
          })
        }

        this.menuItemsWrapperInner.scrollTop = 0

      })
    })

    this.menuItemLinks.forEach(menuItemLink => {
      menuItemLink.addEventListener('mouseenter', () => {

        this.menuItemLinks.forEach(menuItem => {
          menuItem.classList.remove('active')
        })

        menuItemLink.classList.add('active')

        if (menuItemLink.dataset.image) {
          this.fadeImageToSrc(menuItemLink.dataset.image)
        } else {
          this.fadeImageToSrc(this.img.dataset.image)
        }
      })
    })

    var rolodexMenuTL = gsap.timeline({
      paused: true,
      onComplete: () => {
        this.element.querySelectorAll('.menu-item').forEach(menuItem => {
          gsap.to(menuItem, { duration: 1, autoAlpha: 1, ease: 'power2' })
        })
      }
    })

    rolodexMenuTL.to(this.element, { duration: 1, autoAlpha: 1, ease: 'power2' })
    /*
    ctaBannerTL.to(this.video, { duration: 0.5, autoAlpha: 1, scale: 1, ease: 'power2' }, '<')
    ctaBannerTL.to(this.mainHeading, { duration: 1, autoAlpha: 1, ease: 'power2' }, '<')
    ctaBannerTL.to(this.subHeading, { duration: 1, autoAlpha: 1, ease: 'power2' }, '<')
    */

    rolodexMenuTL.play()
  }

  fadeImageToSrc (newSrc) {
    if (!this.img) return
    if (this.img.src === newSrc) return
    gsap.to(this.img, {
      duration: 0.2,
      autoAlpha: 0,
      onComplete: () => {
        // Preload the new image
        this.img.src = newSrc
        gsap.to(this.img, { duration: 0.2, autoAlpha: 1 })
      }
    })
  }
}



// WEBPACK FOOTER //
// ./components/section/rolodex-menu/index.js